import Service from '@ember/service';
import Evented from '@ember/object/evented';
// import { dedupeTracked } from 'tracked-toolbox';
import { tracked } from '@glimmer/tracking';
import { task, rawTimeout } from 'ember-concurrency';
import { add } from 'date-fns';
import jstz from 'jstz';
import { isTesting, macroCondition } from '@embroider/macros';
import { inject as service } from '@ember/service';
export default class ClockService extends Service.extend(Evented) {
  @service intl;

  @tracked interval = 1000;
  @tracked second = 0;
  @tracked minute = 0;
  @tracked five = 0;
  @tracked quarter = 0;
  @tracked hour = 0;
  @tracked time;
  @tracked date;
  offset = 0;

  constructor() {
    super(...arguments);
    // Seed time synchronously before the async task kicks off so that
    // initial renders don't read an unset value that is then updated
    // (which triggers an autotracking assertion).
    this.tick();
    this.start();
  }

  get isFastBoot() {
    return this.fastboot && this.fastboot.isFastBoot;
  }

  @tracked _timeZone;
  get timeZone() {
    return this._timeZone || this.userTimeZone;
  }
  set timeZone(value) {
    this._timeZone = value;
  }

  get userTimeZone() {
    return jstz.determine().name();
  }

  loop = task({ restartable: true }, async () => {
    if (macroCondition(isTesting())) {
      // tick() is already called synchronously from the constructor;
      // don't tick again here or we risk updating tracked state after
      // the initial render has read it.
      return;
    }
    while (true) {
      try {
        await this.tick();
        await rawTimeout(this.interval);
      } catch (e) {
        this.reset();
      }
    }
  });

  start() {
    this.loop.perform();
  }

  stop() {
    this.loop.cancelAll();
  }

  reset() {
    this.stop();
    this.second = 0;
    this.minute = 0;
    this.five = 0;
    this.quarter = 0;
    this.hour = 0;
    this.start();
  }

  tick() {
    let date = add(new Date(), { seconds: this.offset });
    let time = date.getTime();

    let changeSecond = false;
    let changeMinute = false;
    let changeHour = false;

    // we're changing system times, fire everything
    if (this.time && Math.abs(this.time - time) / 1000 > 1) {
      changeSecond = true;
    }
    if (this.time && Math.abs(this.time - time) / 1000 > 60) {
      changeMinute = true;
    }
    if (this.time && Math.abs(this.time - time) / 1000 > 3600) {
      changeHour = true;
    }

    this.time = time;
    this.date = date;

    let seconds = date.getSeconds();
    let minutes = date.getMinutes();
    let hours = date.getHours();
    this.trigger('tick', { date, time });

    if (this.second !== seconds || changeSecond) {
      this.second = seconds;
      this.trigger('tick:second', { date, time });
    }

    if (this.minute !== minutes || changeMinute) {
      this.minute = minutes;
      this.trigger('tick:minute', { date, time });
    }

    if (this.hour !== hours || changeHour) {
      this.hour = hours;
      this.trigger('tick:hour', { date, time });
    }
  }
}
